import { ComponentCategory, ComponentType } from '../../types';

export default {
  name: ComponentType.FormText,
  title: 'Form Text',
  category: ComponentCategory.FormControls,
};
